import { useSelector } from 'react-redux';

const useDomain = () => {
  const selectedDomain = useSelector(state => state.selectedDomain);
  return {
    domain_slug: selectedDomain.slug ?? null,
    domain: selectedDomain.name ?? null
  };
};

export default useDomain;
